// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleView_root__1GxHe","imageContainer":"ArticleView_imageContainer__Q5zpj","image":"ArticleView_image__vE2xH","title":"ArticleView_title__l7qaZ"};